import React from 'react';
import {Text, View, Image, StyleSheet } from '@react-pdf/renderer';
import logo from '../../../../assets/logo.png'

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 10,
        display: 'flex',
        flexDirection: 'row'
    },
    logo: {
        width: 90,
        height: 74,
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'absolute',
        right: 0,
    },
    company: {
        fontSize: 15,
        color: "#c00000",
        fontStyle: "italic",
    },
    address: {
        width: '250px',
        fontStyle: "italic",
    },
    company_contact: {
        fontStyle: "italic",
    },
    gst_in: {
        fontSize: 12,
    },
    billTo: {
        marginTop: 20,
        paddingBottom: 3,
        fontFamily: 'Helvetica-Oblique'
    }
  });


  const BillFrom = ({invoice}) => (
    <View style={styles.headerContainer}>
        <View>
            <Text style={styles.company}>{invoice.company_name}</Text>
            <Text style={styles.address}>{invoice.company_address}</Text>
            <Text style={styles.company_contact}>Ph: {invoice.company_phone}, Email: {invoice.company_email}</Text>
            <Text style={styles.gst_in}>{invoice.company_gst_in}</Text>
        </View>
        <Image style={styles.logo} src={logo} />
    </View>
  );
  
  export default BillFrom